// extracted by mini-css-extract-plugin
var _1 = "n3_7x_IBKHQ5o2Qme0X3";
var _2 = "t_wHciBoJv4G4ONODNEJ";
var _3 = "dPwetsfDopynTrBb5Nqo";
export { _1 as "body", _2 as "children", _3 as "root" }
